import {useMutation, useQuery} from '@tanstack/react-query';
import {
  ButtonType,
  getAdvancedSearchTabsData,
  getCompletedSavedSearchId,
  getMySearchTreeDetails,
  getSearchCount,
  runBackgroundSearchQueue,
} from '../../api/endpoints/searchApi';
import {
  IGetAdvancedSearchTabsDataResponse,
  IGetMySearchTreeDetailsResponse,
  IGetSearchCountResponse,
  IIndexDropdownResponse,
  IRunBackgroundSearchQueueRequest,
  IRunBackgroundSearchQueueResponse,
} from '../../api/types/searchType.type';
import {getIndexDropdown} from '../../api/endpoints/ingestionApi';

export const useGetMySearchTreeDetails = (call: boolean) => {
  return useQuery<IGetMySearchTreeDetailsResponse, Error>({
    queryKey: ['mySearchTreeDetails'],
    queryFn: () => getMySearchTreeDetails(),
    enabled: call,
  });
};

export const useGetAdvancedSearchTabsData = (
  call: boolean,
  buttonType: ButtonType
) => {
  return useQuery<IGetAdvancedSearchTabsDataResponse, Error>({
    queryKey: ['advancedSearchTabsData', buttonType],
    queryFn: () => getAdvancedSearchTabsData(buttonType),
    enabled: call,
  });
};

export const useGetCompletedSavedSearchId = (
  called: boolean,
  SearchGroupId: number
) => {
  return useQuery<any, Error>({
    queryKey: ['getCompletedSavedSearchId', SearchGroupId],
    queryFn: () => getCompletedSavedSearchId(SearchGroupId),
    enabled: !!SearchGroupId && called,
  });
};

export const useGetSearchCount = (searchGroupId: string | number) => {
  return useQuery<IGetSearchCountResponse, Error>({
    queryKey: ['searchCount', searchGroupId],
    queryFn: () => getSearchCount(searchGroupId),
    enabled: false,
  });
};

export const useRunBackgroundSearchQueue = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    IRunBackgroundSearchQueueResponse,
    Error,
    IRunBackgroundSearchQueueRequest
  >({
    mutationFn: runBackgroundSearchQueue,
    mutationKey: ['runBackgroundSearchQueue'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetIndexDropdown = () => {
  return useQuery<IIndexDropdownResponse[], Error>({
    queryKey: ['indexdropdown'],
    queryFn: () => getIndexDropdown(),
    enabled: true,
  });
};
